import { render, staticRenderFns } from "./recycle-detail.vue?vue&type=template&id=1890e61a&scoped=true&"
import script from "./recycle-detail.vue?vue&type=script&lang=js&"
export * from "./recycle-detail.vue?vue&type=script&lang=js&"
import style0 from "./recycle-detail.vue?vue&type=style&index=0&id=1890e61a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1890e61a",
  null
  
)

export default component.exports